import { Avatar, Box, Card, styled, Typography } from '@mui/material'
import { COLORS } from '../../ui/Theme'
import { useSearchParams } from 'react-router-dom'
import { KeyboardDoubleArrowLeft, KeyboardDoubleArrowRight, SelectAll } from '@mui/icons-material'
import { useState } from 'react'
import Loading from '../../components/loader/Loading'
import NotFound from '../../components/notfound/NotFound'

const ItemsBox = styled("div")({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  flexWrap: "wrap",
  gap: "10px",
})

const ItemBox = styled("div")({
  display: "flex", alignItems: "center", justifyContent: "center",
  gap: "6px",
  background: COLORS.INPUTBG,
  border: `1px solid ${COLORS.SOFTGRAY}`,
  padding: "4px 12px",
  fontWeight: "bold",
  borderRadius: "20px",
  width: "fit-content",
  fontSize: "12px",
  ":hover": {
    cursor: "pointer",
    color: COLORS.BLUE,
    background: COLORS.SOFTBLUE,
    border: `1px dashed ${COLORS.BLUE}`,
  }
})

const TableFilteredByKey = ({ title, data, isLoading }) => {
  const [searchParams, setSearchParams] = useSearchParams()

  const [showAll, setShowAll] = useState(false)

  const tableParams = searchParams.get("table-sort") || ""

  const handleClickItem = (value) => {
    const params = new URLSearchParams(searchParams)
    if (value === "all")
      params.delete("table-sort")
    else
      params.set("table-sort", value)

    setSearchParams(params)
  }

  const handleClickShowAll = async () => {
    setShowAll(prev => !prev)

  }


  return (
    <Card >
      <ItemsBox>
        <Box sx={{ display: "flex", gap: 1, alignItems: 'center' }}>
          <Typography sx={{ textWrap: "nowrap", fontWeight: "bold", color: COLORS.GRAY, fontSize: "12px" }}>فیلتر بر اساس </Typography>
          <Typography sx={{ textWrap: "nowrap", fontWeight: "bold" }}>{title}</Typography>
        </Box>

        {isLoading ? <Loading /> : data.length < 0 ? <NotFound /> :
          <>
            <ItemBox
              onClick={() => handleClickItem("all")}
              sx={
                !tableParams && {
                  cursor: "pointer",
                  color: COLORS.BLUE,
                  background: COLORS.SOFTBLUE,
                  border: `1px dashed ${COLORS.BLUE}`,
                }
              }
            >
              <Avatar
                sx={{
                  bgcolor: COLORS.WHITE,
                  color: COLORS.BLUE,
                  width: 28,
                  height: 28,
                }}
              >
                <SelectAll fontSize="small" />
              </Avatar>
              نمایش همه
            </ItemBox>


            {data.slice(0, !showAll ? 6 : data.length).map((item, index) =>
              <SingleItem key={index} item={item} tableParams={tableParams} handleClickItem={handleClickItem} />
            )}

            <Box sx={{
              display: "flex", alignItems: "center", color: COLORS.BLUE, cursor: "pointer",
              borderRadius: 5,
              border: `1px solid ${COLORS.SOFTBLUE}`,
              px: 1,
            }}
              onClick={handleClickShowAll} >
              {
                !showAll ? <KeyboardDoubleArrowLeft fontSize='large' /> : <KeyboardDoubleArrowRight fontSize='large' />
              }
            </Box>

          </>
        }
      </ItemsBox>


    </Card >
  )
}

export default TableFilteredByKey

const SingleItem = ({ item, handleClickItem, tableParams }) => {

  return (
    <>
      <ItemBox onClick={() => handleClickItem(item)} sx={tableParams === item && {
        cursor: "pointer",
        color: COLORS.BLUE,
        background: COLORS.SOFTBLUE,
        border: `1px dashed ${COLORS.BLUE}`,
      }}>
        <Avatar
          sx={{ bgcolor: COLORS.WHITE, color: COLORS.BLUE, width: 28, height: 28, }}
          alt={item}
          src="#"
        />
        {item}
      </ItemBox>
    </>)
} 